export default {
  code: 'Coupon Code',
  couponError: 'Coupon is not valid',
  couponSuccess: 'Coupon added successfully.',
  addCoupon: 'Add Coupon'
};



// WEBPACK FOOTER //
// ./src/components/forms/checkout-form/CheckoutForm.messages.js